<h1 mat-dialog-title>Dodawanie karty płatniczej</h1>

<p *ngIf="step === 'start'">
  Kwota 1zł zostanie pobrana z Twojej karty w celu weryfikacji.<br />
  Po ukończeniu procesu kwota zostanie zwrócona.<br />
</p>

<p *ngIf="step === 'success'">
  <ng-container *ngIf="fromPayment; else notFromPayment">
    Karta została dodana pomyślnie. Wróć do koszyka, aby dokończyć płatność.
  </ng-container>

  <ng-template #notFromPayment>
    Gotowe. Po pomyślnej weryfikacji, karta pojawi się<br />
    na tym ekranie. Może to potrwać kilka minut.
  </ng-template>
</p>

<p *ngIf="step === 'failure'">
  Nie udało się dodać karty. Karta może być nieaktywna<br />
  lub brakuje na niej środków. Spróbuj ponownie.
</p>

<mat-dialog-actions align="start">
  <ng-container *ngIf="step === 'start'; else close">
    <button mat-raised-button color="accent" matDialogClose="continue" cdkFocusInitial>Dalej</button>
    <button mat-button matDialogClose="cancel">Anuluj</button>
  </ng-container>

  <ng-template #close>
    <button mat-button matDialogClose="close">Zamknij</button>
  </ng-template>
</mat-dialog-actions>
